(function () {

    'use strict';

    var app = angular.module('app');
    var baseApiPath = "https://localhost:8417/";

    app.factory('tmxStoreSubscriptionService', ['$q', '$resource', tmxStoreSubscriptionService]);

    function tmxStoreSubscriptionService($q, $resource) {

        var subscription = $resource(baseApiPath + 'api/clients/:email/subscription');

        var subscriptionService = {
            getClientSubscription: getClientSubscription
        }

        return subscriptionService;

        function getClientSubscription(email) {
            return subscription.get({ email: email }).$promise;
        }

    }

})();